import { DepartamentoReadingFiltersDtoProps } from "api/DTOs/DepartamentoReadingFiltersDto"
import { DepartamentoReadingFiltersDtoIPagedEnumerableProps } from "api/Schemas/DepartamentoReadingFiltersDtoIPagedEnumerable"

export default (lista: DepartamentoReadingFiltersDtoIPagedEnumerableProps) =>
  lista?.items?.map((departamentos: DepartamentoReadingFiltersDtoProps) => ({
    id: departamentos.id,
    nombre: departamentos.nombre,
    numeroUsuarios: departamentos.numeroUsuarios,
    "DepartamentoUsuarios.Count": departamentos.numeroUsuarios,
    responsableNombres: departamentos.responsableNombres,
    "DepartamentoUsuarios.Count(du=>du.Rol==2)":
      departamentos.responsableNombres,
  }))
